    import React, { useEffect, useState } from 'react';
    import './DashboardPage.css';
    import { useNavigate } from 'react-router-dom';
    import citiesData from '../data/CitiesData'; // 🔧 EN ÜSTE EKLE
    import Navbar from '../components/NavBar';
    import { jwtDecode } from 'jwt-decode';  // named import olarak


    const DashboardPage = () => {
      const navigate = useNavigate();
      const [projects, setProjects] = useState([]);
      const [loading, setLoading] = useState(true);
      const [showModal, setShowModal] = useState(false);
      const [newProjectName, setNewProjectName] = useState('');
      const [username, setUsername] = useState('');
      const [showDropdown, setShowDropdown] = useState(false);
      const [showUploadModal, setShowUploadModal] = useState(false);
const [showFileUploadModal, setShowFileUploadModal] = useState(false);
const [selectedProjectForUpload, setSelectedProjectForUpload] = useState(null);
const [uploadedFilesTemp, setUploadedFilesTemp] = useState([]);
      const [showUsernameModal, setShowUsernameModal] = useState(false);
    const [newUsername, setNewUsername] = useState('');
    const [showEditOptions, setShowEditOptions] = useState(false);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [showProjectInfoEditModal, setShowProjectInfoEditModal] = useState(false);
    const [editingProjectInfo, setEditingProjectInfo] = useState(null); // proje bilgileri
    const [showContactModal, setShowContactModal] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [passwordData, setPasswordData] = useState({
      currentPassword: '',
      newPassword: ''
    });
    const [contactInfo, setContactInfo] = useState({
      company: '',
      person: '',
      phone: ''
    });
    const [newProjectLocation, setNewProjectLocation] = useState('');
    const [climateData, setClimateData] = useState({
      altitude: '',
      winterDB: '',
      summerDB: '',
      summerWB: ''
    });
    const [editingClimate, setEditingClimate] = useState(false);



    const toggleDropdown = () => {
      setShowDropdown((prev) => !prev);
    };

    const handleAccountOption = (option) => {
      setShowDropdown(false);
      if (option === 'contact') {
        setShowContactModal(true);
      } else if (option === 'username') {
        setShowUsernameModal(true);
      } else if (option === 'password') {
        setShowPasswordModal(true); // 🔧 modalı aç
      }
    };


    // Dış tıklamada dropdown menüyü kapat
    useEffect(() => {

      

      const handleClickOutside = (event) => {
        if (!event.target.closest('.user-dropdown')) {
          setShowDropdown(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    // 🔔 Navbar'dan gelen özel eventleri yakala
  useEffect(() => {
    const contactHandler = () => setShowContactModal(true);
    const usernameHandler = () => setShowUsernameModal(true);
    const passwordHandler = () => setShowPasswordModal(true);

    document.addEventListener('openContactModal', contactHandler);
    document.addEventListener('openUsernameModal', usernameHandler);
    document.addEventListener('openPasswordModal', passwordHandler);

    return () => {
      document.removeEventListener('openContactModal', contactHandler);
      document.removeEventListener('openUsernameModal', usernameHandler);
      document.removeEventListener('openPasswordModal', passwordHandler);
    };
  }, []);


    useEffect(() => {
      const selected = citiesData.find(city => city.name === newProjectLocation.toUpperCase());
      if (selected) {
        setClimateData({
          altitude: selected.altitude,
          winterDB: selected.winterDB,
          summerDB: selected.summerDB,
          summerWB: selected.summerWB
        });
      }
    }, [newProjectLocation]);

      useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/giris');
          return;
        }

        try {
          const decoded = jwtDecode(token);
          console.log('📦 JWT içeriği:', decoded); // burayı konsolda kontrol et
          setUsername(decoded.username || '');
        } catch (error) {
          console.error('Token decode edilirken hata:', error);
          // Token geçersizse çıkış yap
          localStorage.removeItem('token');
          navigate('/giris');
          return;
        }

        const fetchProjects = async () => {
          try {
            const response = await fetch('https://klima-backend-ggo2.onrender.com/api/projects', {
              headers: { Authorization: `Bearer ${token}` },
            });

            if (response.status === 401) {
              alert('Oturumunuz sona erdi. Lütfen tekrar giriş yapınız.');
              localStorage.removeItem('token');
              navigate('/giris');
              return;
            }

            const data = await response.json();

            if (!response.ok) {
              throw new Error(data.message || 'Projeler alınamadı.');
            }

            setProjects(data);
          } catch (err) {
            alert('Projeler yüklenirken hata oluştu: ' + err.message);
          } finally {
            setLoading(false);
          }
        };

        fetchProjects();
      }, [navigate]);

      const handleCreateProject = async (redirectToDesign = false) => {
        const token = localStorage.getItem('token');
        if (!token) {
          alert('Giriş yapmanız gerekiyor.');
          navigate('/giris');
          return;
        }

        if (!newProjectName.trim()) {
          alert('Lütfen proje adını girin.');
          return;
        }

    const newProject = {
      projectName: newProjectName.trim(),
      location: newProjectLocation,
      altitude: Number(climateData.altitude),
      winterDryTemp: Number(climateData.winterDB),
      summerDryTemp: Number(climateData.summerDB),
      summerWetTemp: Number(climateData.summerWB),
    };

        try {
          const response = await fetch('https://klima-backend-ggo2.onrender.com/api/projects', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(newProject),
          });

          if (response.status === 401) {
            alert('Oturumunuz sona erdi. Lütfen tekrar giriş yapınız.');
            localStorage.removeItem('token');
            navigate('/giris');
            return;
          }

          const data = await response.json();

          if (!response.ok) {
            throw new Error(data.message || 'Proje oluşturulamadı.');
          }

          setProjects(prev => [data.project, ...prev]);
          setShowModal(false);
          setNewProjectName('');
          localStorage.setItem('activeProjectId', data.project._id);

          if (redirectToDesign) {
            navigate(`/tasarim?edit=${data.project._id}`);
          }
        } catch (err) {
          alert('Proje oluşturulurken hata oluştu: ' + err.message);
        }
      };

      const handleEditProject = (projectId) => {
      const project = projects.find(p => p._id === projectId);
      if (project?.offerRequested) {
        handleCancelOfferRequest(projectId);
      } else {
        setSelectedProjectId(projectId);
        setShowEditOptions(true);
      }
    };




      const handleDeleteProject = async (projectId) => {
        if (!window.confirm('Bu projeyi silmek istediğinize emin misiniz?')) return;

        const token = localStorage.getItem('token');
        try {
          const response = await fetch(`https://klima-backend-ggo2.onrender.com/api/projects/${projectId}`, {
            method: 'DELETE',
            headers: { Authorization: `Bearer ${token}` },
          });

          if (response.status === 401) {
            alert('Oturumunuz sona erdi. Lütfen tekrar giriş yapınız.');
            localStorage.removeItem('token');
            navigate('/giris');
            return;
          }

          if (!response.ok) {
            const data = await response.json();
            throw new Error(data.message || 'Silme işlemi başarısız.');
          }

          setProjects(prev => prev.filter(p => p._id !== projectId));
        } catch (err) {
          alert('Silme sırasında hata oluştu: ' + err.message);
        }
      };

      // 🔽 🔽 🔽 BURAYA EKLE 🔽 🔽 🔽

      const handleCancelOfferRequest = async (projectId) => {
      if (!window.confirm('Bu projede daha önce teklif istenmiş. Düzenlemeye geçmeden önce bu isteği iptal etmek istiyor musunuz?')) {
        return;
      }

      const token = localStorage.getItem('token');
      try {
        const res = await fetch(`https://klima-backend-ggo2.onrender.com/api/projects/${projectId}/request-offer`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ offerRequested: false })
        });

        if (!res.ok) throw new Error('Güncellenemedi');

        setProjects((prev) =>
          prev.map((p) => (p._id === projectId ? { ...p, offerRequested: false } : p))
        );

        alert('🔄 Teklif isteği iptal edildi. Artık proje tekrar düzenlenebilir.');
        setSelectedProjectId(projectId);
        setShowEditOptions(true);
      } catch (err) {
        alert('❌ Teklif iptali başarısız: ' + err.message);
      }
    };

    const handleRequestOffer = async (projectId, bypassContactCheck = false) => {
      if (!bypassContactCheck && (!contactInfo.company || !contactInfo.person || !contactInfo.phone)) {
        setShowContactModal(true);
        return;
      }

      if (!bypassContactCheck && !window.confirm('Proje için Kayıtlı Firmalardan teklif istenecektir. Onaylıyor musunuz?')) return;

      const token = localStorage.getItem('token');
      try {
        const res = await fetch(`https://klima-backend-ggo2.onrender.com/api/projects/${projectId}/request-offer`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ offerRequested: true }),
        });

        if (!res.ok) throw new Error('Güncellenemedi');

        setProjects((prev) =>
          prev.map((p) => (p._id === projectId ? { ...p, offerRequested: true } : p))
        );

        if (!bypassContactCheck) {
          alert('✅ Teklif isteği başarıyla iletildi.');
        }
      } catch (err) {
        alert('❌ Teklif isteği gönderilemedi: ' + err.message);
      }
    };


    const handleSaveContactInfo = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('Giriş yapmanız gerekiyor.');
        navigate('/giris');
        return;
      }

      if (!contactInfo.company || !contactInfo.person || !contactInfo.phone) {
        alert('Lütfen tüm iletişim bilgilerini doldurun.');
        return;
      }

      try {
        const res = await fetch(`https://klima-backend-ggo2.onrender.com/api/projects/${projects[0]?._id}/contact-info`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(contactInfo)
        });

        if (!res.ok) throw new Error('Bilgiler kaydedilemedi.');

        alert('İletişim bilgileriniz kaydedildi.');
        setShowContactModal(false);

        await handleRequestOffer(projects[0]?._id, true); // ✅ teklif isteğini tetikle

      } catch (err) {
        alert('❌ Hata oluştu: ' + err.message);
      }
    };

      const handleUsernameChange = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('Giriş yapmanız gerekiyor.');
        return;
      }

      try {
        const response = await fetch('https://klima-backend-ggo2.onrender.com/api/auth/update-username', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ newUsername }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || 'Kullanıcı adı değiştirilemedi.');
        }

        alert('Kullanıcı adınız başarıyla değiştirildi.');
        setUsername(newUsername);
        setShowUsernameModal(false);
        setNewUsername('');
      } catch (error) {
        alert('Hata oluştu: ' + error.message);
      }
    };

    const handleChangePassword = async () => {
      const token = localStorage.getItem('token');
      if (!token) return alert('Giriş yapmanız gerekiyor.');

      const { currentPassword, newPassword } = passwordData;

      if (!currentPassword || !newPassword) {
        return alert('Lütfen her iki şifreyi de giriniz.');
      }

      try {
        const response = await fetch('https://klima-backend-ggo2.onrender.com/api/auth/update-password', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ currentPassword, newPassword }),
        });

        const data = await response.json();

        if (!response.ok) throw new Error(data.message || 'Şifre değiştirilemedi.');

        alert('Şifreniz başarıyla değiştirildi.');
        setShowPasswordModal(false);
        setPasswordData({ currentPassword: '', newPassword: '' });
      } catch (error) {
        alert('Hata: ' + error.message);
      }
    };

      const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/giris');
      };

    return (
      <>
        <Navbar username={username} />
        <div style={{ padding: 20, maxWidth: 900, margin: '0 auto', position: 'relative' }}>
        {/* Başlık ve Kullanıcı + Çıkış Butonu yatay hizalı */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2>📁 Kayıtlı Projeler</h2>

  
          </div>

          {loading ? (
            <p style={{ textAlign: 'center' }}>Yükleniyor...</p>
          ) : projects.length === 0 ? (
            <p style={{ textAlign: 'center' }}>Henüz kayıtlı proje yok.</p>
          ) : (
           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: 20 }}>
              {projects.map((proj) => (
                <div
                  key={proj._id}
                  style={{
                    border: '1px solid #ddd',
                    borderRadius: 8,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    padding: 20,
                    backgroundColor: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transition: 'transform 0.2s',
                    cursor: 'pointer',
                    position: 'relative', // 🔧 BU SATIRI EKLE
                  }}
                  onClick={() => handleEditProject(proj._id)}
                >
                  <div>
                    <button
      className="project-edit-icon"
      onClick={(e) => {
        e.stopPropagation();
        setEditingProjectInfo(proj);
        setNewProjectName(proj.projectName);
        setNewProjectLocation(proj.location);
        setClimateData({
          altitude: proj.altitude,
          winterDB: proj.winterDryTemp,
          summerDB: proj.summerDryTemp,
          summerWB: proj.summerWetTemp,
        });
        setShowProjectInfoEditModal(true);
      }}
      title="Proje bilgilerini düzenle"
    >
      🖉
    </button>

                    <h3>{proj.projectName || 'İsimsiz Proje'}</h3>
                    <p>
                      <strong>Konum:</strong> {proj.location}
                    </p>
                    <p style={{ fontSize: '0.85rem', color: '#777' }}>
                      Oluşturulma: {new Date(proj.createdAt).toLocaleString()}
                    </p>
                    <p style={{ fontSize: '0.85rem', color: '#555' }}>
  Klima Santrali: {proj.units?.filter(u => u.type !== 'hru' && u.type !== 'fan' && u.type !== 'vrf').length || 0} adet
</p>


    <p style={{ fontSize: '0.85rem', color: '#555' }}>
    IGK Cihazı: {proj.units?.filter(u => u.type === 'hru').length || 0} adet
    </p>

    <p style={{ fontSize: '0.85rem', color: '#555' }}>
  VRF / VRV Ürünü: {
    proj.units?.filter(u => u.type === 'vrf')
               .reduce((sum, u) => sum + (Number(u.quantity) || 0), 0)
    || 0
  } adet
</p>

   <p style={{ fontSize: '0.85rem', color: '#555' }}>
  Fan Grubu: {
    proj.units?.filter(u => u.type === 'fan')
               .reduce((sum, u) => sum + (Number(u.quantity) || 0), 0)
    || 0
  } adet
</p>


                  </div>
                 <div style={{ marginTop: 15, display: 'flex', gap: 10 }}>
  <button
    onClick={(e) => {
      e.stopPropagation();
      handleEditProject(proj._id);
    }}
    style={{
      backgroundColor: '#4caf50',
      color: 'white',
      padding: '8px 12px',
      border: 'none',
      borderRadius: 5,
      cursor: 'pointer',
      flex: 1,
    }}
  >
    Ürün Grubu
  </button>

  <button
    onClick={(e) => {
      e.stopPropagation();
      handleDeleteProject(proj._id);
    }}
    style={{
      backgroundColor: '#f44336',
      color: 'white',
      padding: '8px 12px',
      border: 'none',
      borderRadius: 5,
      cursor: 'pointer',
      flex: 1,
    }}
  >
    Projeyi Sil
  </button>

  <button
    onClick={(e) => {
      e.stopPropagation();
      setSelectedProjectForUpload(proj);
      setUploadedFilesTemp(proj.uploadedFiles || []);
      setShowFileUploadModal(true);
    }}
    style={{
      backgroundColor: '#9c27b0',
      color: 'white',
      padding: '8px 12px',
      border: 'none',
      borderRadius: 5,
      cursor: 'pointer',
      flex: 1,
    }}
  >
    Döküman Yükle (Opsiyonel)
  </button>
</div>

                  {/* 🔵 Teklif İste Butonu */}
    <div style={{ marginTop: 10 }}>
      <button
        onClick={(e) => {
          e.stopPropagation();
          if (!proj.offerRequested) handleRequestOffer(proj._id);
        }}
        disabled={proj.offerRequested}
        style={{
          backgroundColor: proj.offerRequested ? '#607d8b' : '#1976d2',
          color: 'white',
          width: '100%',
          padding: '10px 16px',
          fontSize: 16,
          fontWeight: 'bold',
          borderRadius: 6,
          border: 'none',
          cursor: proj.offerRequested ? 'not-allowed' : 'pointer',
        }}
      >
        {proj.offerRequested ? '✓ Teklif İstendi' : '📩 Teklif İste'}
      </button>
    </div>

                </div>
              ))}
            </div>
          )}

          <div style={{ textAlign: 'center', marginTop: 40 }}>
            <button
              onClick={() => setShowModal(true)}
              style={{
                fontSize: 18,
                padding: '12px 24px',
                borderRadius: 6,
                cursor: 'pointer',
                backgroundColor: '#1976d2',
                color: 'white',
                border: 'none',
              }}
            >
              ➕ Yeni Proje Ekle
            </button>
          </div>

        {/* MODAL */}
    {showModal && (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            backgroundColor: '#fff',
            padding: 30,
            borderRadius: 10,
            width: '90%',
            maxWidth: 420,
            textAlign: 'center',
          }}
        >
          <h3 style={{ marginBottom: 15 }}>📝 Yeni Proje Oluştur</h3>
          <input
      type="text"
      value={newProjectName}
      onChange={(e) => setNewProjectName(e.target.value)}
      placeholder="Proje adı giriniz"
      style={{
        width: '100%',
        padding: '10px 14px',
        marginBottom: 20,
        borderRadius: 6,
        border: '1px solid #ccc',
        fontSize: '16px',
        height: '48px',           // 👈 BURAYI EKLEDİK
        boxSizing: 'border-box',  // 👈 taşma olmasın diye
      }}
    />

          <select
      value={newProjectLocation}
      onChange={(e) => {
        setNewProjectLocation(e.target.value);
        setEditingClimate(false);
      }}
      style={{
      width: '100%',
        padding: '10px 14px',
        marginBottom: '12px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        fontSize: '16px',
        lineHeight: '1.4',
        height: '48px',           // 🔧 yükseklik sabitlendi
        boxSizing: 'border-box',  // 🔧 taşmayı önler
        overflow: 'hidden',       // 🔧 uzun metin taşmasın
        textOverflow: 'ellipsis', // 🔧 ... ile sonlandır
        whiteSpace: 'nowrap',     // 🔧 tek satırda tut
        backgroundColor: 'white',
        color: '#333',
      }}
    >
      <option value="">Proje Konumu Seçiniz</option>
      {citiesData.map((city, i) => (
        <option key={i} value={city.name}>
          {city.name}
        </option>
      ))}
    </select>

    {!editingClimate ? (
      <>
        <div style={{ fontSize: 14, marginBottom: 10, color: '#333' }}>
          Rakım: {climateData.altitude} m | Kış KT: {climateData.winterDB} °C | Yaz KT: {climateData.summerDB} °C | Yaz YT: {climateData.summerWB} °C
        </div>
        <button
          onClick={() => setEditingClimate(true)}
          style={{ fontSize: 13, backgroundColor: '#eee', border: 'none', padding: '4px 10px', borderRadius: 6, cursor: 'pointer', marginBottom: 20 }}
        >
          Değerleri Değiştir
        </button>
      </>
    ) : (
      <div style={{ marginBottom: 20 }}>
        {[
      { label: 'Proje Rakım (metre)', key: 'altitude' },
      { label: 'Kış Kuru Termometre (°C)', key: 'winterDB' },
      { label: 'Yaz Kuru Termometre (°C)', key: 'summerDB' },
      { label: 'Yaz Yaş Termometre (°C)', key: 'summerWB' },
    ].map(({ label, key }, i) => (
      <div key={i} style={{ marginBottom: 8 }}>
        <label style={{ fontSize: 13 }}>{label.toUpperCase()}:</label>
        <input
          type="number"
          value={climateData[key]}
          onChange={(e) => setClimateData({ ...climateData, [key]: e.target.value })}
          style={{
            width: '100%',
            padding: 10,
            borderRadius: 5,
            border: '1px solid #ccc',
          }}
        />
      </div>
    ))}
      </div>
    )}


          <button
            onClick={() => handleCreateProject(false)}
            style={{
              marginBottom: 15,
              padding: 12,
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              fontSize: 16,
              cursor: 'pointer',
              width: '100%',
            }}
          >
            💾 Projeyi Kaydet
          </button>

          <button
            onClick={() => setShowModal(false)}
            style={{
              background: 'none',
              border: 'none',
              color: '#555',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: 14,
            }}
          >
            Vazgeç
          </button>
        </div>
      </div>
    )}

    {/* 🛠️ Cihaz Türü Seçim MODAL */}
    {showEditOptions && (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999,
        }}
      >
        <div
          style={{
            backgroundColor: '#fff',
            padding: 30,
            borderRadius: 12,
            width: '90%',
            maxWidth: 420,
            textAlign: 'center',
            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
          }}
        >
          <h3 style={{ marginBottom: 15 }}>🛠️ Düzenlemek istediğiniz cihaz türünü seçin:</h3>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <button
              onClick={() => navigate(`/tasarim?edit=${selectedProjectId}`)}
              style={{
                padding: '12px 18px',
                backgroundColor: '#4caf50',
                color: 'white',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                fontSize: 16,
              }}
            >
              🌬️ Klima Santrali Düzenle
            </button>
            <button
              onClick={() => navigate(`/igk?edit=${selectedProjectId}`)}
              style={{
                padding: '12px 18px',
                backgroundColor: '#03a9f4',
                color: 'white',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                fontSize: 16,
              }}
            >
              ♻️ IGK Cihazı Düzenle
            </button>

            <button
  onClick={() => navigate(`/vrf?edit=${selectedProjectId}`)}
  style={{
    padding: '12px 18px',
    backgroundColor: '#6a1b9a', // mor
    color: 'white',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontSize: 16,
  }}
>
  🏢 VRF / VRV Sistemi Düzenle
</button>


            <button
onClick={() => navigate(`/fan?edit=${selectedProjectId}`)}
  style={{
    padding: '12px 18px',
    backgroundColor: '#ff9800', // turuncu
    color: 'white',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontSize: 16,
  }}
>
  🌀 Fan Grubu Düzenle
</button>

            <button
              onClick={() => setShowEditOptions(false)}
              style={{
                marginTop: 10,
                background: 'none',
                border: 'none',
                color: '#555',
                cursor: 'pointer',
                textDecoration: 'underline',
                fontSize: 14,
              }}
            >
              Vazgeç
            </button>
          </div>
        </div>
      </div>
    )}
    {showProjectInfoEditModal && (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <div
          style={{
            backgroundColor: '#fff',
            padding: 30,
            borderRadius: 10,
            width: '90%',
            maxWidth: 420,
            textAlign: 'center',
          }}
        >
          <h3 style={{ marginBottom: 15 }}>🔧 Proje Bilgilerini Güncelle</h3>

     <input
  type="text"
  value={newProjectName}
  onChange={(e) => setNewProjectName(e.target.value)}
  placeholder="Proje adı"
  style={{
    width: '100%',
    padding: '10px 14px',
    marginBottom: 15,
    borderRadius: 5,
    border: '1px solid #ccc',
    fontSize: '16px',
    height: '48px',           // ✅ il kutusuyla aynı yükseklik
    boxSizing: 'border-box',  // ✅ içeriğin taşmaması için
  }}
/>


          <select
      value={newProjectLocation}
      onChange={(e) => {
        setNewProjectLocation(e.target.value);
        setEditingClimate(false);
      }}
      style={{
        width: '100%',
        padding: '10px 14px',
        marginBottom: '12px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        fontSize: '16px',
        lineHeight: '1.4',
        height: '48px',           // 🔧 yükseklik sabitlendi
        boxSizing: 'border-box',  // 🔧 taşmayı önler
        overflow: 'hidden',       // 🔧 uzun metin taşmasın
        textOverflow: 'ellipsis', // 🔧 ... ile sonlandır
        whiteSpace: 'nowrap',     // 🔧 tek satırda tut
        backgroundColor: 'white',
        color: '#333',
      }}
    >

            <option value="">Proje Konumu Seçiniz</option>
            {citiesData.map((city, i) => (
              <option key={i} value={city.name}>
                {city.name}
              </option>
            ))}
          </select>

          {!editingClimate ? (
            <>
              <div style={{ fontSize: 14, marginBottom: 10 }}>
                Rakım: {climateData.altitude} m | Kış KT: {climateData.winterDB} °C |
                Yaz KT: {climateData.summerDB} °C | Yaz YT: {climateData.summerWB} °C
              </div>
              <button
                onClick={() => setEditingClimate(true)}
                style={{ fontSize: 13, backgroundColor: '#eee', border: 'none', padding: '4px 10px', borderRadius: 6, cursor: 'pointer', marginBottom: 20 }}
              >
                Değerleri Değiştir
              </button>
            </>
          ) : (
            <div style={{ marginBottom: 20 }}>
              {[
                { label: 'Rakım (m)', key: 'altitude' },
                { label: 'Kış KT (°C)', key: 'winterDB' },
                { label: 'Yaz KT (°C)', key: 'summerDB' },
                { label: 'Yaz YT (°C)', key: 'summerWB' },
              ].map(({ label, key }, i) => (
                <div key={i} style={{ marginBottom: 8 }}>
                  <label>{label}</label>
                  <input
                    type="number"
                    value={climateData[key]}
                    onChange={(e) =>
                      setClimateData({ ...climateData, [key]: e.target.value })
                    }
                    style={{
                      width: '100%',
                      padding: 10,
                      borderRadius: 5,
                      border: '1px solid #ccc',
                    }}
                  />
                </div>
              ))}
            </div>
          )}

          <button
            onClick={async () => {
              if (!editingProjectInfo) return;

              const token = localStorage.getItem('token');
              const updatedProject = {
                ...editingProjectInfo,
                projectName: newProjectName,
                location: newProjectLocation,
                altitude: Number(climateData.altitude),
                winterDryTemp: Number(climateData.winterDB),
                summerDryTemp: Number(climateData.summerDB),
                summerWetTemp: Number(climateData.summerWB),
              };

              try {
                const res = await fetch(
                  `https://klima-backend-ggo2.onrender.com/api/projects/${editingProjectInfo._id}`,
                  {
                    method: 'PUT',
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(updatedProject),
                  }
                );

                if (!res.ok) throw new Error('Güncelleme başarısız.');

                setProjects((prev) =>
                  prev.map((p) =>
                    p._id === editingProjectInfo._id ? updatedProject : p
                  )
                );

                alert('✅ Proje bilgileri güncellendi.');
                setShowProjectInfoEditModal(false);
              } catch (err) {
                alert('❌ Güncelleme hatası: ' + err.message);
              }
            }}
            style={{
              marginBottom: 15,
              padding: 12,
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              fontSize: 16,
              cursor: 'pointer',
              width: '100%',
            }}
          >
            Kaydet
          </button>

          <button
            onClick={() => setShowProjectInfoEditModal(false)}
            style={{
              background: 'none',
              border: 'none',
              color: '#555',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: 14,
            }}
          >
            Vazgeç
          </button>
        </div>
      </div>
    )}

    {showContactModal && (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999,
        }}
      >
        <div
          style={{
            backgroundColor: '#fff',
            padding: 30,
            borderRadius: 12,
            width: '90%',
            maxWidth: 420,
            textAlign: 'center',
          }}
        >
          <h3 style={{ marginBottom: 15 }}>📇 İletişim Bilgileriniz</h3>

          <input
            type="text"
            placeholder="Firma Adı"
            value={contactInfo.company}
            onChange={(e) => setContactInfo({ ...contactInfo, company: e.target.value })}
            style={{ marginBottom: 10, width: '100%', padding: 10, borderRadius: 5, border: '1px solid #ccc' }}
          />
          <input
            type="text"
            placeholder="Yetkili Adı Soyadı"
            value={contactInfo.person}
            onChange={(e) => setContactInfo({ ...contactInfo, person: e.target.value })}
            style={{ marginBottom: 10, width: '100%', padding: 10, borderRadius: 5, border: '1px solid #ccc' }}
          />
          <input
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      placeholder="İletişim Numarası"
      value={contactInfo.phone}
      onChange={(e) => {
        const onlyNums = e.target.value.replace(/\D/g, '');
        setContactInfo({ ...contactInfo, phone: onlyNums });
      }}
    />

          <button
      onClick={handleSaveContactInfo}
      style={{
        backgroundColor: '#1976d2',
        color: 'white',
        padding: 12,
        width: '100%',
        border: 'none',
        borderRadius: 6,
        fontSize: 16,
        cursor: 'pointer',
      }}
    >
      Kaydet
    </button>

          <button
            onClick={() => setShowContactModal(false)}
            style={{
              marginTop: 10,
              background: 'none',
              border: 'none',
              color: '#555',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: 14,
            }}
          >
            Vazgeç
          </button>
        </div>
      </div>
    )}

    {showUsernameModal && (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <div
          style={{
            backgroundColor: '#fff',
            padding: 30,
            borderRadius: 10,
            width: '90%',
            maxWidth: 400,
            textAlign: 'center',
          }}
        >
          <h3 style={{ marginBottom: 15 }}>✏️ Kullanıcı Adı Değiştir</h3>
          <input
            type="text"
            value={newUsername}
            onChange={(e) => setNewUsername(e.target.value)}
            placeholder="Yeni kullanıcı adınız"
            style={{
              width: '100%',
              padding: 12,
              marginBottom: 20,
              borderRadius: 5,
              border: '1px solid #ccc',
            }}
          />
          <button
            onClick={handleUsernameChange}
            style={{
              padding: 12,
              width: '100%',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              fontSize: 16,
              cursor: 'pointer',
            }}
          >
            Kaydet
          </button>
          <button
            onClick={() => setShowUsernameModal(false)}
            style={{
              marginTop: 10,
              background: 'none',
              border: 'none',
              color: '#555',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: 14,
            }}
          >
            Vazgeç
          </button>
        </div>
      </div>
    )}

    {showPasswordModal && (
      <div style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        zIndex: 1000,
      }}>
        <div style={{
          backgroundColor: '#fff',
          padding: 30,
          borderRadius: 10,
          width: '90%',
          maxWidth: 400,
          textAlign: 'center',
        }}>
          <h3 style={{ marginBottom: 15 }}>🔑 Şifre Değiştir</h3>
          <input
            type="password"
            placeholder="Mevcut Şifreniz"
            value={passwordData.currentPassword}
            onChange={(e) => setPasswordData({ ...passwordData, currentPassword: e.target.value })}
            style={{
              width: '100%',
              padding: 12,
              marginBottom: 15,
              borderRadius: 5,
              border: '1px solid #ccc',
            }}
          />
          <input
            type="password"
            placeholder="Yeni Şifreniz"
            value={passwordData.newPassword}
            onChange={(e) => setPasswordData({ ...passwordData, newPassword: e.target.value })}
            style={{
              width: '100%',
              padding: 12,
              marginBottom: 20,
              borderRadius: 5,
              border: '1px solid #ccc',
            }}
          />
          <button
            onClick={handleChangePassword}
            style={{
              padding: 12,
              width: '100%',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              fontSize: 16,
              cursor: 'pointer',
            }}
          >
            Kaydet
          </button>
          <button
            onClick={() => setShowPasswordModal(false)}
            style={{
              marginTop: 10,
              background: 'none',
              border: 'none',
              color: '#555',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: 14,
            }}
          >
            Vazgeç
          </button>
        </div>
      </div>
    )}

    </div> {showFileUploadModal && selectedProjectForUpload && (
  <div style={{
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
    justifyContent: 'center', alignItems: 'center', zIndex: 999
  }}>
    <div style={{
      backgroundColor: '#fff', padding: 30, borderRadius: 12,
      width: '90%', maxWidth: 420, textAlign: 'center'
    }}>
      <h3 style={{ marginBottom: 15 }}>📎 Dosya Yükle</h3>
      <input
        type="file"
        multiple
        onChange={(e) => {
          const files = Array.from(e.target.files);
          const totalSizeMB = files.reduce((total, f) => total + f.size, 0) / (1024 * 1024);
          if (totalSizeMB > 30) return alert('Toplam dosya boyutu 30 MB\'ı geçemez.');
          for (let file of files) {
            if (file.size > 5 * 1024 * 1024) return alert(`${file.name} dosyası 5 MB'tan büyük.`);
          }
          const mapped = files.map(file => ({
            file,
            originalName: file.name,
            size: file.size
          }));
          setUploadedFilesTemp(prev => [...prev, ...mapped]);
        }}
        style={{ marginBottom: 15 }}
      />

{uploadedFilesTemp.length > 0 && (
  <>
    <h4 style={{ marginBottom: 6 }}>✅ Kaydedilen Dosyalar</h4>
    <ul style={{ textAlign: 'left', fontSize: 14, marginTop: 10 }}>
      {uploadedFilesTemp.map((f, i) => (
        <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {f.serverName ? (
            <a
              href={`https://klima-backend-ggo2.onrender.com/uploads/${f.serverName}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              📎 {f.originalName}
            </a>
          ) : (
            <span>📎 {f.originalName}</span>
          )}
         <button
  onClick={async () => {
    if (!window.confirm(`${f.originalName} dosyasını silmek istiyor musunuz?`)) return;

    // 🔹 Yalnızca localde olan dosyaysa, diziden çıkar
    if (!f.serverName) {
      setUploadedFilesTemp(prev => prev.filter((_, idx) => idx !== i));
      return;
    }

    try {
      const res = await fetch('https://klima-backend-ggo2.onrender.com/api/upload/delete-file', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fileName: f.serverName }),
      });

      if (!res.ok) throw new Error('Silinemedi');

      const updatedProject = {
        ...selectedProjectForUpload,
        uploadedFiles: (selectedProjectForUpload.uploadedFiles || []).filter(
          file => file.serverName !== f.serverName
        ),
      };

      const token = localStorage.getItem('token');
      const updateRes = await fetch(`https://klima-backend-ggo2.onrender.com/api/projects/${updatedProject._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updatedProject),
      });

      if (!updateRes.ok) throw new Error('Proje güncellenemedi');

      setProjects(prev => prev.map(p => (p._id === updatedProject._id ? updatedProject : p)));
      setSelectedProjectForUpload(updatedProject);
      setUploadedFilesTemp(prev => prev.filter((_, idx) => idx !== i));
      alert('🗑️ Dosya silindi');
    } catch (err) {
      alert('❌ Dosya silinirken hata oluştu: ' + err.message);
    }
  }}
  style={{
    backgroundColor: '#e53935',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '4px 8px',
    cursor: 'pointer',
  }}
>
  Sil
</button>

        </li>
      ))}
    </ul>
  </>
)}


      <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
        <button
          onClick={async () => {
            const formData = new FormData();
            uploadedFilesTemp.forEach(f => formData.append('files', f.file));
            try {
              const res = await fetch('https://klima-backend-ggo2.onrender.com/api/upload', {
                method: 'POST',
                body: formData
              });
              const data = await res.json();
              if (!res.ok) throw new Error('Dosya yükleme hatası');

              const uploaded = data.uploadedFiles.map((serverName, idx) => ({
                serverName,
                originalName: uploadedFilesTemp[idx].originalName,
                size: uploadedFilesTemp[idx].size
              }));

              const updated = {
                ...selectedProjectForUpload,
                uploadedFiles: [...(selectedProjectForUpload.uploadedFiles || []), ...uploaded]
              };

              const token = localStorage.getItem('token');
              const updateRes = await fetch(`https://klima-backend-ggo2.onrender.com/api/projects/${updated._id}`, {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(updated),
              });

              if (!updateRes.ok) throw new Error('Proje güncellenemedi');

              setProjects(prev => prev.map(p => p._id === updated._id ? updated : p));
              setUploadedFilesTemp([]);
              setSelectedProjectForUpload(null);
              setShowFileUploadModal(false);
              alert('✅ Dosyalar yüklendi');
            } catch (err) {
              alert('❌ Hata oluştu: ' + err.message);
            }
          }}
          style={{ flex: 1, backgroundColor: '#1976d2', color: 'white', padding: 10, borderRadius: 6 }}
        >
          Kaydet
        </button>

        <button
          onClick={() => {
            setShowFileUploadModal(false);
            setSelectedProjectForUpload(null);
            setUploadedFilesTemp([]);
          }}
          style={{ flex: 1, backgroundColor: '#ccc', padding: 10, borderRadius: 6 }}
        >
          Vazgeç
        </button>
      </div>
    </div>
  </div>
)}

      </>
    );
    };



    export default DashboardPage;
